import {Switch, TableCell, TableRow} from '@material-ui/core';
import React from 'react';
import {makeStyles} from '@material-ui/styles';

const useStyles = makeStyles(() => ({
    titleCell: {
        // width: '40%',
    },
    dataCell: {
        // width: '60%',
    },
}));

export const TableRowToggle = (props: {
    name: string,
    title: string,
    value?: boolean,
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void,
}) => {
    const classes = useStyles();

    return (
        <TableRow>
            <TableCell className={classes.titleCell}>{props.title}</TableCell>
            <TableCell className={classes.dataCell}>
                <Switch
                    checked={props.value}
                    color="primary"
                    edge="start"
                    name={props.name}
                    onChange={props.onChange}
                    value={props.value}
                />
            </TableCell>
        </TableRow>
    );
};

export default TableRowToggle;